export default __webpack_public_path__ + "static/media/2.ce01b098.jpg";